import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { emptyToUndefined } from "@/utils/format.util";
import { useMemberProfile } from "../MemberProfileContext";
import { OwnedField } from "./FormFields";
import { FormShell } from "./ProfileOverlayShell";
import type { FormProps } from "./types";

const familyFormSchema = z.object({
    mustKnow: z.string(),
});

type FamilyFormValues = z.infer<typeof familyFormSchema>;

export function FamilyForm({ onClose }: FormProps) {
    const { profile, saveFamilyNotes } = useMemberProfile();
    const { control, handleSubmit } = useForm<FamilyFormValues>({
        resolver: zodResolver(familyFormSchema),
        defaultValues: { mustKnow: profile.familyMustKnow ?? "" },
    });

    function onSubmit(values: FamilyFormValues) {
        saveFamilyNotes({ familyMustKnow: emptyToUndefined(values.mustKnow) }, onClose);
    }

    return (
        <FormShell
            title="Edit family"
            onClose={onClose}
            onSave={handleSubmit(onSubmit)}
        >
            <OwnedField
                id="family-must-know"
                label="Must know"
                kind="textarea"
                control={control}
                name="mustKnow"
            />
        </FormShell>
    );
}
